import { render, staticRenderFns } from "./EmployeeWizardPfOnly.vue?vue&type=template&id=824a8742"
import script from "./EmployeeWizardPfOnly.vue?vue&type=script&lang=js"
export * from "./EmployeeWizardPfOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports